import React from "react";
import { getAllTimezones, getTimezoneLabel, getUserLocalTimezone } from "../../utils/timezoneUtils";

// Reusable timezone selector component
// @param {object} props - Component props
// @param {string} props.value - Selected timezone
// @param {function} props.onChange - Change handler
// @param {string} props.id - HTML ID for the select element
// @param {string} props.label - Label text (optional)
// @param {string} props.description - Description text (optional)
function TimezoneSelector({
  value,
  onChange,
  id,
  label = "Your Timezone",
  description = "Select your timezone to receive emails at a convenient time for you.",
}) {
  const allTimezones = getAllTimezones();
  const userLocalTz = getUserLocalTimezone();
  // Ensure user's local timezone is shown at the top if not already selected
  const timezones = userLocalTz && allTimezones.indexOf(userLocalTz) === -1
    ? [userLocalTz, ...allTimezones]
    : allTimezones;

  return (
    <div className="timezone-selector">
      {label && <label htmlFor={id}>{label}</label>}
      {description && <div className="timezone-description">{description}</div>}
      <select
        id={id}
        value={value}
        onChange={onChange}
        className="timezone-dropdown"
      >
        {userLocalTz && (
          <option value={userLocalTz} key={userLocalTz}>
            {getTimezoneLabel(userLocalTz)} (Your local timezone)
          </option>
        )}
        {timezones
          .filter((tz) => tz !== userLocalTz)
          .map((tz) => (
            <option value={tz} key={tz}>
              {getTimezoneLabel(tz)}
            </option>
          ))}
      </select>
    </div>
  );
}

export default TimezoneSelector;
